/*
  シンプルなアコーディオン制御
  - 親 .accordion の data-single="true" の場合は一度に1つだけ開く
  - 各 .item の aria-expanded 属性を更新
  - max-height を使ってアニメーション（内容の高さに応じる）
*/
(function(){
  const accordion = document.getElementById('faq');
  if(!accordion) return;
  const single = accordion.dataset.single === "true";
  const items = Array.from(accordion.querySelectorAll('.item'));

  // 初期化: 各 answer-wrap の高さを 0 に
  items.forEach(item => {
    const wrap = item.querySelector('.answer-wrap');
    wrap.style.maxHeight = '0px';
  });

  function openItem(item){
    const wrap = item.querySelector('.answer-wrap');
    const answer = wrap.querySelector('.answer');
    // 高さを一時的に auto にして scrollHeight を取得
    wrap.style.maxHeight = wrap.scrollHeight + 'px';
    item.setAttribute('aria-expanded','true');
  }

  function closeItem(item){
    const wrap = item.querySelector('.answer-wrap');
    wrap.style.maxHeight = '0px';
    item.setAttribute('aria-expanded','false');
  }

  function toggleItem(item){
    const expanded = item.getAttribute('aria-expanded') === 'true';
    if(expanded){
      closeItem(item);
    } else {
      if(single){
        // 他を閉じる
        items.forEach(it => {
          if(it !== item) closeItem(it);
        });
      }
      openItem(item);
    }
  }

  // イベント割り当て
  accordion.addEventListener('click', (e) => {
    const btn = e.target.closest('.question');
    if(!btn) return;
    const item = btn.closest('.item');
    toggleItem(item);
  });

  // キーボードで Space/Enter が効くように
  accordion.addEventListener('keydown', (e) => {
    // ボタンが target か、その祖先かを判定
    const btn = e.target.closest('.question');
    if(!btn) return;
    if(e.code === 'Space' || e.code === 'Enter'){
      e.preventDefault();
      const item = btn.closest('.item');
      toggleItem(item);
    }
  });

  // ウィンドウリサイズ時に開いている項目の max-height を再計算
  window.addEventListener('resize', () => {
    items.forEach(item => {
      if(item.getAttribute('aria-expanded') === 'true'){
        const wrap = item.querySelector('.answer-wrap');
        // 再計算して正しい高さをセット
        wrap.style.maxHeight = wrap.scrollHeight + 'px';
      }
    });
  });
})();

const targets = document.querySelectorAll('.fade-in, .fade-in1, .fade-in2, .fade-in3, .fade-in4');

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('show');
    }
  });
});

targets.forEach(target => observer.observe(target));